import React from 'react';
import { translate } from 'utils/common';
import classNames from 'classnames/bind';
class RadioGroup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.cbRadioChange = this.cbRadioChange.bind(this);
    }
    componentDidMount() {
    }

    cbRadioChange(item) {
        this.props.onChange({ target: { inputtype: 'radio', name: this.props.name, value: item.value } });
    }
    render() {
        var clsnames = classNames({
            'flex-column': this.props.align=="vertical",
        })
        return (<React.Fragment>
            <div className={"d-flex "+clsnames}>
                {this.props.options && this.props.name &&
                    this.props.options.map((o, i) =>
                        <div key={'radio' + this.props.name + i} className="custom-control custom-radio custom-control-inline mb-1">
                            <input onChange={() => this.cbRadioChange(o)} type="radio"
                                checked={this.props.value == o.value}
                                disabled={(o.disabled || this.props.disabled) ? true : null}
                                id={this.props.name + i} name={this.props.name} className="custom-control-input" />
                            <label className="custom-control-label" htmlFor={this.props.name + i}>{translate(o.text)}</label>
                        </div>
                    )
                }
            </div>
            
        </React.Fragment>
        )
    }
}

export default RadioGroup;